import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FindOptions, FindProductsQuery, InvitationProductApi } from 'api';

export const findInvitationProduct = createAsyncThunk(
  'invitationProduct/findInvitationProduct',
  async (options: FindOptions, { rejectWithValue }) => {
    try {
      const response = await InvitationProductApi.find(options);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findInvitationProductForUpdateInvitation = createAsyncThunk(
  'invitationProduct/findInvitationProductForUpdateInvitation',
  async (options: any, { rejectWithValue }) => {
    try {
      const response = await InvitationProductApi.findForUpdateInvitation(
        options
      );
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface InvitationProductState {
  data: any[];
}

const initialState: InvitationProductState = {
  data: [],
};

const invitationProductSlice = createSlice({
  name: 'invitationProduct',
  initialState,
  reducers: {},
  //   extraReducers: builder => {},
});

const { reducer: invitationProductReducer } = invitationProductSlice;

export default invitationProductReducer;
